import { useTranslation } from 'react-i18next';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  ModalFooter,
  Button,
} from 'reactstrap';

const PromotedContentModal = ({
  promotedCancelModal,
  setPromotedCancelModal,
  completePromotedCancellation,
  checkedPromotedContent,
}) => {
  const { t } = useTranslation(['review_changes', 'buttons']);

  return (
    <Modal isOpen={promotedCancelModal} centered={true}>
      <ModalHeader>{t('revchn_promoted_content_label')}</ModalHeader>
      <ModalBody>
        <Form>
          <FormGroup>
            <Label>
              {checkedPromotedContent?.length > 1
                ? t('revchn_cancel_all_changes')
                : t('revchn_cancel_changes')}
            </Label>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color='danger' onClick={() => completePromotedCancellation()}>
          {t('buttons:btn_yes')}
        </Button>
        <Button color='success' onClick={() => setPromotedCancelModal(false)}>
          {t('buttons:btn_no')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PromotedContentModal;
